import { render } from "./MobMenu.vue?vue&type=template&id=2f1b08a4&scoped=true"
import script from "./MobMenu.vue?vue&type=script&lang=js"
export * from "./MobMenu.vue?vue&type=script&lang=js"

import "./MobMenu.vue?vue&type=style&index=0&id=2f1b08a4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1b08a4"]])

export default __exports__